import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'
import router from './router'
import store from './store'
import './assets/css/base.css'
// import './plugins/element.js'

import axios from 'axios'
import { zhuge } from './utils/zhuge'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/resetEle.css'

Vue.use(ElementUI)
import '@longfor/ma-icon'

zhuge.init()
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.imgUrl = 'https://img.longfor.com' // 获取头像

console.log('test-Chris Wong 20231205');
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
